import * as React from "react"

import { Button } from "@/components/ui/button"

/**
 * Last line of defence. A render error anywhere below this leaves a blank page
 * otherwise, which in a chat app looks identical to a network failure — so the
 * fallback names what happened and offers the one action that reliably helps.
 */
type Props = { children: React.ReactNode }
type State = { error: Error | null }

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("unhandled render error:", error, info.componentStack)
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <div className="flex h-(--app-height,100dvh) flex-col items-center justify-center gap-3 bg-background px-8 text-center text-foreground">
        <h1 className="text-xl font-semibold">Что-то сломалось</h1>
        <p className="max-w-[46ch] text-sm leading-relaxed text-muted-foreground">
          Приложение столкнулось с ошибкой, которую не удалось обработать.
          Обычно помогает перезагрузка.
        </p>
        <pre className="no-scrollbar max-w-full overflow-auto rounded-md border bg-muted px-3 py-2 font-mono text-xs">
          {error.message}
        </pre>
        <Button variant="outline" onClick={() => location.reload()}>
          Перезагрузить
        </Button>
      </div>
    )
  }
}
